
export const townName = 'Sudwest-Fryslan'